import { Component, OnInit, TemplateRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { ToastrService } from 'ngx-toastr';
import { Prix, PrixService } from '../../liste-prix/prix.service';

@Component({
  selector: 'app-croud-integration',
  templateUrl: './croud-integration.component.html',
  styleUrls: ['./croud-integration.component.scss']
})
export class CroudIntegrationComponent implements OnInit {
  @ViewChild('modalLG') modalTemplate!: TemplateRef<any>;
  @Output() prixAdded = new EventEmitter<void>();
  @Output() prixUpdated = new EventEmitter<Prix>();
  private modalRef!: NgbModalRef;
  modalType: 'ajouter' | 'update' | 'etat' = 'ajouter';
  selectedPrix: Prix | null = null;
  priceName: string = '';
  idStation: number | null = null;
  clientId: number | null = null;
  isLoading: boolean = false;
  showErrorOnce: boolean = false; 
  constructor(private modalService: NgbModal, private prixService: PrixService, private toastr: ToastrService) {}

  ngOnInit(): void {
  }
  
  openModal(type: 'ajouter'): void {

    const options: NgbModalOptions = {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false
    };
    this.modalRef = this.modalService.open(this.modalTemplate, options);
  }
}
